import { SampleKey } from 'types/generated/graphql';
import { CreatorBpmMultiplier } from 'controllers/business/Creator/Creator.types';
import { CreatorSessionTrack } from './CreatorSessionTrack';

declare global {
    interface Window {
        AudioContext: AudioContext;
        webkitAudioContext: AudioContext;
    }
}

// Sample once in CreatorSession
export type CreatorTrackConfigType = {
    id: string;
    bpm: number;
    bpmMultiplier: CreatorBpmMultiplier;
    duration: number | null;
    gain: number;
    key: SampleKey | null;
    name: string;
    stream: Response;
    pitchTranspose: number | undefined;
    isAutoload: boolean | undefined;
};

export type CreatorTrackMapType = Map<string, CreatorSessionTrack>;

export enum CreatorPlaybackAction {
    START = 'START',
}

export type CreatorPlaybackEvent = {
    time: number;
    trackId: string;
    action: CreatorPlaybackAction.START;
};

export type CreatorMixdownTrackType = {
    dyadicLengthInSamples: number;
    gain: number;
    channelL: Float32Array;
    channelR: Float32Array;
};
